import { render, staticRenderFns } from "./AdminDrivers.vue?vue&type=template&id=d5e57e56&scoped=true"
import script from "./AdminDrivers.vue?vue&type=script&lang=js"
export * from "./AdminDrivers.vue?vue&type=script&lang=js"
import style0 from "./AdminDrivers.vue?vue&type=style&index=0&id=d5e57e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e57e56",
  null
  
)

export default component.exports